import { __rest } from "tslib";
import React from 'react';
import Tabs from '../../../tabs';
import classnames from 'classnames';
const MainTabs = (props) => {
    const { fixedTabs, mainTabs, prefixCls } = props;
    const { items } = mainTabs, otherProps = __rest(mainTabs, ["items"]);
    const resetProps = Object.assign(Object.assign({}, otherProps), { type: 'editable-card', hideAdd: true });
    const tabsCls = classnames(`${prefixCls}-main-tabs`, {
        [`${prefixCls}-main-tabs-fixed`]: fixedTabs,
    });
    const newItems = items === null || items === void 0 ? void 0 : items.map((item) => {
        var _a;
        return Object.assign(Object.assign({}, item), { children: null, label: (_a = item.text) !== null && _a !== void 0 ? _a : '' });
    });
    return (React.createElement("div", { className: tabsCls },
        React.createElement(Tabs, Object.assign({}, resetProps, { items: newItems !== null && newItems !== void 0 ? newItems : [] }))));
};
export default MainTabs;
